<template>
  <vxe-grid
    auto-resize
    highlight-hover-row
    :data="tableData"
    :toolbar-config="tableToolbar"
    :columns="tableColumns"
    :loading="loading"
    :height="300"
    size="mini"
    resizable
    border
    round
    :radio-config="{ highlight: true, trigger: 'row', strict: false }"
    @radio-change="(e) => $emit('radio-change', e)"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:specInfo="{ row }">
      <span>{{ row.spec }} {{ row.specUnit }}</span>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
